import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import memoizeOne from 'memoize-one';

var makeEncDecFromFn = function makeEncDecFromFn(fn) {
  return {
    encode: memoizeOne(function (data) {
      return fn(undefined, data);
    }),
    decode: memoizeOne(function (str) {
      return fn(str, undefined);
    })
  };
};

var identity = function identity(arg) {
  return arg;
};

function makeEncDecFromObj(obj) {
  return {
    encode: obj.encode ? memoizeOne(obj.encode) : identity,
    decode: obj.decode ? memoizeOne(obj.decode) : identity
  };
}

function makeParamEncDec(arg) {
  if (typeof arg === 'function') {
    return makeEncDecFromFn(arg);
  } else if (_typeof(arg) === 'object' && arg !== null) {
    return makeEncDecFromObj(arg);
  } else {
    return {
      encode: function encode(arg) {
        return arg;
      },
      decode: function decode(arg) {
        return arg;
      }
    };
  }
}
function makeParamsEncDec(arg) {
  if (typeof arg === 'function') {
    return makeEncDecFromFn(arg);
  } else if (_typeof(arg) === 'object' && arg !== null) {
    var qp = {};

    var _ref = arg;
        _ref.encode;
        _ref.decode;
        var others = _objectWithoutProperties(_ref, ["encode", "decode"]);

    var global = makeEncDecFromObj(arg);
    var memoized = {};

    for (var _k in others) {
      if (typeof others[_k] === 'function') {
        memoized[_k] = makeEncDecFromFn(others[_k]);
      } else if (_typeof(others[_k]) === 'object') {
        memoized[_k] = makeEncDecFromObj(others[_k]);
      }
    }

    qp.encode = memoizeOne(function (data) {
      var out = global.encode(data);

      for (var _k2 in memoized) {
        out[_k2] = memoized[_k2].encode(data[_k2]);
      }

      return out;
    });
    qp.decode = memoizeOne(function (data) {
      var out = global.decode(data);

      for (var _k3 in memoized) {
        out[_k3] = memoized[_k3].decode(data[_k3]);
      }

      return out;
    });
    return qp;
  } else {
    return {
      encode: function encode(arg) {
        return arg;
      },
      decode: function decode(arg) {
        return arg;
      }
    };
  }
}

export { makeParamsEncDec as a, makeParamEncDec as m };
